<template>
    <section>
        <main>
            <router-view></router-view>
        </main>
    </section>
</template>

<script>
export default {
    
}
</script>

<style src="./assets/tailwind.css"> 

</style>